import { isArray } from 'lodash';

export default class URLUtils {
    static urlToFilter(filter?: any) {
        let filters = '';
        if (filter) {
            Object.keys(filter).forEach((e) => {
                const val: any = filter[e];
                if (val) {
                    if (isArray(val)) {
                        filters = filters + `&${val.map((v) => `${e}[]=${encodeURIComponent(v)}`).join('&')}`;
                    } else {
                        filters = filters + `&${e}=${encodeURIComponent(filter[e])}`;
                    }
                }
            });
        }
        return filters;
    }
}
